export default __webpack_public_path__ + "static/media/3602.b20ea637.svg";